import { useState } from 'react';
import { Link } from 'react-router-dom';

const NEWSLETTER_URL = 'https://readdy.ai/api/form/d71mgb9lum2co2q1fqgg';

const footerLinks = {
  COLLECTION: [
    { label: 'Bullion Emblem', path: '/embroidery' },
    { label: 'Handmade Embroidery', path: '/embroidery' },
    { label: 'Custom Orders', path: '/contact' },
    { label: 'Shopping', path: '/shopping' },
  ],
  BRAND: [
    { label: 'About Us', path: '/about' },
    { label: 'Gallery', path: '/gallery' },
    { label: 'Contact', path: '/contact' },
    { label: 'Home', path: '/' },
  ],
};

export default function Footer() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleNewsletter = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) {
      setError('이메일 주소를 입력해주세요.');
      return;
    }
    try {
      const body = new URLSearchParams({ email });
      await fetch(NEWSLETTER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      setSubmitted(true);
      setEmail('');
      setError('');
    } catch {
      setError('구독 처리 중 오류가 발생했습니다. 다시 시도해주세요.');
    }
  };

  return (
    <footer className="bg-cream-dark pt-16 pb-8">
      {/* Gold top border */}
      <div className="w-full h-px bg-gradient-to-r from-transparent via-gold/50 to-transparent mb-16" />

      <div className="px-16 max-w-[1400px] mx-auto">
        {/* Main footer grid */}
        <div className="grid grid-cols-12 gap-12 mb-16">
          {/* Brand column */}
          <div className="col-span-4">
            <Link to="/" className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-full overflow-hidden flex items-center justify-center">
                <img
                  src="https://static.readdy.ai/image/f580c0f570e01fa5cfa022cd23f0387f/c4bef23fb78eb416165c97f7f86256da.jpeg"
                  alt="HivanTex"
                  className="w-full h-full object-cover"
                />
              </div>
              <span className="font-serif text-lg tracking-[0.18em] text-charcoal uppercase">
                HivanTex
              </span>
            </Link>
            <p className="text-charcoal/50 text-xs leading-7 font-sans font-light mb-8 tracking-wide">
              불리온 엠블럼과 핸드메이드 자수 전문 브랜드.<br />
              장인의 손끝에서 탄생하는 예술로<br />
              귀사의 브랜드 아이덴티티를 완성합니다.
            </p>
            {/* Newsletter */}
            <div>
              <p className="text-[10px] tracking-[0.2em] text-charcoal/40 uppercase font-sans mb-4">
                Newsletter
              </p>
              {submitted ? (
                <p className="text-gold text-xs font-sans tracking-wide">
                  구독해주셔서 감사합니다.
                </p>
              ) : (
                <form
                  onSubmit={handleNewsletter}
                  data-readdy-form
                  id="newsletter-footer"
                  className="flex flex-col gap-3"
                >
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="이메일 주소 입력"
                    className="bg-transparent border-b border-charcoal/30 text-charcoal text-xs pb-2 placeholder-charcoal/30 focus:outline-none focus:border-gold transition-colors duration-200 font-sans"
                  />
                  {error && (
                    <p className="text-red-500 text-xs font-sans">{error}</p>
                  )}
                  <button
                    type="submit"
                    className="self-start border border-charcoal/40 text-charcoal/70 text-[10px] tracking-[0.2em] uppercase px-6 py-2 hover:border-gold hover:text-gold transition-all duration-200 font-sans whitespace-nowrap cursor-pointer"
                  >
                    구독하기
                  </button>
                </form>
              )}
            </div>
          </div>

          {/* Link columns */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title} className="col-span-2">
              <h4 className="text-[10px] tracking-[0.2em] text-charcoal uppercase font-sans font-medium mb-6">
                {title}
              </h4>
              <ul className="space-y-4">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-charcoal/50 text-xs font-sans font-light hover:text-gold transition-colors duration-200 tracking-wide"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Contact info */}
          <div className="col-span-4">
            <h4 className="text-[10px] tracking-[0.2em] text-charcoal uppercase font-sans font-medium mb-6">
              CONTACT
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-gold text-xs" />
                </div>
                <span className="text-charcoal/50 text-xs font-sans font-light leading-5">
                  서울특별시 강남구
                </span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line text-gold text-xs" />
                </div>
                <span className="text-charcoal/50 text-xs font-sans font-light">
                  02-000-0000
                </span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-gold text-xs" />
                </div>
                <span className="text-charcoal/50 text-xs font-sans font-light">
                  info@hivantex.com
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-charcoal/10 pt-8 flex items-center justify-between">
          <p className="text-charcoal/30 text-[10px] tracking-[0.15em] font-sans uppercase">
            &copy; 2026 HivanTex. All Rights Reserved.
          </p>
          <div className="flex items-center gap-1 text-charcoal/30 text-[10px] tracking-[0.1em] font-sans">
            <span>불리온 엠블럼</span>
            <span className="mx-2">·</span>
            <span>핸드메이드 자수</span>
            <span className="mx-2">·</span>
            <span>맞춤 제작</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
